module.exports = __webpack_public_path__ + "static/img/1.322b96d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/6/zh/1.png
// module id = Na4b
// module chunks = 0